<template>
  <div style="background-color: #F8F8F8;">
    <!-- 轮播图 -->
    <banner></banner>
    <!-- 头部组件 -->
    <v-header :inputName='Name' @reloadAll="reloadAll"></v-header>
    <!-- <div style="width:100%;height:400px;position: relative;"></div> -->
    <item1></item1>

    <!-- <div id="ad" style="position:fixed;top:600px">
      <a><a><img src="../../static/img/gg.png" border="0"></a>
      </a>
      <div onClick="hidead();" style="font-size: 9px; cursor: hand" align=right>关闭广告×</div>
    </div> -->



    <zuoxuanfu1></zuoxuanfu1>
    <!-- <item3></item3> -->
    <item2 v-if="newsInfo!=null" :newsInfo="newsInfo" style="margin-top: 15px;min-height: 500px;"></item2>
    <!-- <item4></item4> -->
    <!-- <item5></item5> -->
    <item6 v-if="$WebName"></item6>
    <item7></item7>
    <div class="mask" v-if="showcaozuo">
      <div class="maskA" :style="{width:maskWidth+'px'}">
        <div class="maskAA"  :style="{width:maskWidth+'px'}">
          <p>{{open.masktitle}}</p>
          <img @click="closemask" src="../../src/assets/img/cha.png" />
        </div>
        <div class="ANANi">
          <figure v-for="item in open.maskcontent">
            <figcaption>{{item}}</figcaption>
          </figure>
        </div>
        <div style="width: 100%;height: 40px;display: flex;justify-content: center;">
          <div style="width: 100px;height: 40px; font-size:16px;background-color: #F44F25;
          border-radius: 20px;color: #ffffff;text-align: center;line-height: 40px;" @click="closemask">关闭</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import "./css/reset.css"
  import "./css/style.css"
  import "./js/jquery-1.8.3.min.js"
  import vHeader from '../components/vHeader.vue'
  import banner from "./home/banner.vue"
  import item1 from "./home/classifi.vue"
  import item2 from "./home/consult.vue"
  import item3 from "./home/form.vue"
  import item4 from "./home/item4.vue"
  import item5 from "./home/item5.vue"
  import item6 from "./home/item6.vue"
  import item7 from "../components/item7.vue"
  import zuoxuanfu1 from '../components/zuoxuanfu1.vue'
  export default {
    components: {
      vHeader,
      banner,
      item1,
      item2,
      item3,
      item4,
      item5,
      item6,
      item7,
      zuoxuanfu1
    },
    data() {
      return {
        Name: 1,
        denglu: false,
        dialogVisible: false,
        newsparent: {},
        newsInfo: null,
        scoreInfo: "",
        memberInfo: "",
        userInfo: "",
        AREA_OBJ: {},
        showcaozuo:false,
        open:{},
        maskWidth:500,
      }
    },
    inject:[
      'reload'
    ],
    mounted() {

      // this.$http.get('https://ip.ws.126.net/ipquery?ip=119.179.50.116').then(function(res){
      //   console.log(res)
      // })
    },
    methods: {
      reloadAll(){
        this.reload()
      },
      getMsgFormSon(data) {
        this.denglu = data
        // console.log(this.msgFormSon)
      },
      qudiao() {
        this.denglu = false
      },
      closemask(){
        this.$utils.setlocalStorage(this.open.name,1)
        this.showcaozuo = false;
      },
      getData() {

        let _this = this;
        _this.$http.get(_this.$resourcesUrl + "/data/news.json?time=" + new Date().getTime()).then(function(
          resp) {
            console.log("222")
            if(resp.open){
              console.log(_this.$utils.getlocalStorage(resp.name))
              if(!_this.$utils.getlocalStorage(resp.name)){
                _this.maskWidth =resp.maskWidth
                _this.open = resp
                _this.showcaozuo = true;
              }
            }
        })

        let NEWSPARENT = this.$utils.getlocalStorage('NEWSPARENT')
        _this.userInfo = this.$utils.getlocalStorage('userInfo')
        this.scoreInfo = this.$utils.getlocalStorage('scoreInfo')
        if (NEWSPARENT != null && NEWSPARENT != undefined) {
          _this.newsparent = NEWSPARENT;
          _this.getNewdata();
        } else {

          _this.$http.get(_this.$resourcesUrl + "/data/keyValue.json?time=" + new Date().getTime()).then(function(
            response) {
			_this.$utils.setlocalStorage('TISHI', response.TISHI)
            _this.$utils.setlocalStorage('AREA_LIST', response.AREA_LIST)
            _this.$utils.setlocalStorage('AREA_OBJ', response.AREA_OBJ)
            _this.$utils.setlocalStorage('COLLEGELEVEL', response.COLLEGELEVEL)
            _this.$utils.setlocalStorage('COLLEGESUBJECT', response.COLLEGESUBJECT)
            _this.$utils.setlocalStorage('MAJORPARENTTYPELIST', response.MAJORPARENTTYPELIST)
            _this.$utils.setlocalStorage('MAJORPARENTTYPEOBJ', response.MAJORPARENTTYPEOBJ)
            _this.$utils.setlocalStorage('NEWSPARENT', response.NEWSPARENT)
            _this.$utils.setlocalStorage('MAJORTYPEOBJ', response.MAJORTYPEOBJ)
            _this.$utils.setlocalStorage('NEWSTYPELIST', response.NEWSTYPELIST)
            _this.$utils.setlocalStorage('NEWSTYPEOBJ', response.NEWSTYPEOBJ)
            _this.$utils.setlocalStorage('NEWSAllOBJ', response.NEWSAllOBJ)
            _this.$utils.setlocalStorage('SUBJECTTYPELIST', response.SUBJECTTYPELIST)
            _this.$utils.setlocalStorage('SUBJECTTYPEOBJ', response.SUBJECTTYPEOBJ)
            let xuankeArea = {
              xingaokao: response.xingaokao,
              xingaokao2: response.xingaokao2,
              xingaokao3: response.xingaokao3,
              xingaokao4: response.xingaokao4,
              xingaokao5: response.xingaokao5,
              xingaokao6: response.xingaokao6,
              yishuarea: response.yishuarea,
            }
            _this.$utils.setlocalStorage('xuankeArea', xuankeArea)
            _this.newsparent = response.NEWSPARENT;
            _this.getNewdata();
          })
        }
      },
      getNewdata() {
        let _this = this;
        let areaId = "990000";
        if (_this.userInfo != null && _this.userInfo != "") {
          areaId = _this.userInfo.userProvinces
        }
        this.$req.queryIndexNews({
          areaid: areaId
        }).then(function(response) {
          _this.newsInfo = {}
          _this.newsInfo.newsZun = response.data.zun
          _this.newsInfo.newsDan = response.data.dan
        })
      },


    },
    created() {
      this.getData();
    }
  }
</script>

<style scoped>
  /* 遮罩层  ↓ */
  .mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 120;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .maskA {
    width: 500px;
    /* height: 300px; */
    padding-bottom: 30px;
    background: rgb(255, 255, 255);
    border-radius: 20px;
    position: fixed;
    left: 47%;
    top: 45%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  }

  .maskAA {
    width: 500px;
    height: 64px;
    background-image: url("../assets/img/zzctop.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 28px;
    padding-left: 28px;
    margin-bottom: 10px;
    box-sizing: border-box;
  }

  .maskAA img {
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  .ANANi {
    width: 100%;
    padding-bottom: 10px;
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 20px;
    /* height: calc(100% - 170px); */
    /* height: 380px; */
  }

  .maskAA p {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }

  .ANANi figure {
    display: flex;
    margin-bottom: 18px;

  }

  .ANANi figure span {
    margin-right: 15px;
    background-color: #F44F25;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 18px;
    border-radius: 15px;
    width: 25px;
    height: 25px;
  }

  .ANANi figure figcaption {
    text-indent: 1cm;
    font-size: 16px;
    /* line-height: 30px; */
    color: #F53824;
    font-family: PingFang SC;
    font-weight: 500;
  }

  .loginBody2 {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    z-index: 9999;
  }

  .loginAuto {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
  }

  * {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  a,
  img {
    border: 0;
  }



  .ad {
    position: relative;
  }

  .fixed {
    position: fixed;
    z-index: 100;
    margin-top: 30px;
    width: 200px;
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/views/home.vue